{
  "meta": {
    "employeeProfile": "Profil de l’employé",
    "employeeInfo": "Informations sur l’employé",
    "employeeCreate": "Création d’un employé",
    "employeeEdit": "Modification de l’employé",
    "employeeList": "Utilisateurs"
  },
  "employee": "Utilisateurs",
  "employeers": "Utilisateurs",
  "new-employee": "Nouvel utilisateur",
  "active": "Actif",
  "deleteEmployee": "Supprimer l’tilisateur",
  "inactive": "Inactif",
  "create-employee": "Ajouter un utilisateur",
  "edit-employee": "",
  "relevantCandidates": "Candidats pertinents",
  "successDeleted": "supprimé avec succès",
  "employeeDeleted": "Employé supprimé",
  "filters": "Filtres",
  "failDelete": "Impossible de supprimer l’employé",
  "deleteConfirmRectutier": "Confirmez la suppression de l’utilisateur ; toutes ses offres seront transférées au gestionnaire de l’entreprise.",
  "surname": "Nom",
  "name": "Prénom",
  "phone": "Téléphone",
  "phoneNumber": "Numéro de téléphone",
  "role": "Rôle",
  "activity": "Activité",
  "vacancy": "Offres créées",
  "breadcrumbs": {
    "new": "Nouvel utilisateur"
  },
  "form": {
    "select": "Sélectionnez",
    "surname": {
      "title": "Nom",
      "description": "",
      "placeholder": "Entrez le nom"
    },
    "name": {
      "title": "Prénom",
      "description": "",
      "placeholder": "Entrez le prénom"
    },
    "email": {
      "title": "Email",
      "description": "",
      "placeholder": "exemple@test.fr"
    },
    "phone": {
      "title": "Numéro de téléphone",
      "description": "",
      "placeholder": "+225 "
    },
    "group": {
      "title": "Rôle",
      "description": "",
      "placeholder": "Sélectionnez un groupe de rôle"
    },
    "company": {
      "title": "Entreprise",
      "description": ""
    },
    "password": {
      "title": "Mot de passe",
      "description": "Mot de passe pour accéder au système",
      "placeholder": "Le mot de passe doit contenir au moins 8 caractéres"
    },
    "confirmPassword": {
      "title": "Confirmation du mot de passe",
      "description": "Confirmation du mot de passe",
      "placeholder": ""
    },
    "personalData": "Données personnelles"
  },
  "error": {
    "create": "Erreur lors de la création de l’employé",
    "update": "Erreur lors de la mise à jour de l’employé"
  }
}
